module.exports = __webpack_public_path__ + "img/p33.0f4af2a4.svg";